import { createActions, handleActions } from 'redux-actions';
import { destroy as destroyForm } from 'redux-form';
import Notifications from 'react-notification-system-redux';
import {
    defaultPaginationData,
    getPaginationAndOrderData,
} from '../../shared/utils';

const actions = createActions({
    CONTACTREASSIGNS: {
        LIST: {
            FETCHING: currentPage => ({ currentPage }),
            LOADED: list => ({ list }),
        },
        UPDATE: {
            UPDATING: undefined,
            UPDATED: contactReAssign => ({ contactReAssign }),
        },
        ADD: {
            ADDING: undefined,
            ADDED: contactReAssign => ({ contactReAssign }),
        },
        REMOVE: {
            PROMPT: ({ contactReAssignId, contactReAssignName }) => ({
                contactReAssignId,
                contactReAssignName,
            }),
            REMOVING: undefined,
            REMOVED: undefined,
            RESET: undefined,
        },
    },
});

const initialState = Object.assign(
    {},
    {
        list: Object.assign(
            {},
            {
                error: null,
                fetching: false,
                fetchingTime: null,
                contactReAssign: null,
                currentPage: 1,
            },
            defaultPaginationData
        ),
        update: {
            error: null,
            updating: false,
        },
        add: {
            error: null,
            adding: false,
        },
        remove: {
            contactReAssignId: null,
            contactReAssignName: null,
            removing: false,
        },
    }
);

let fetchingTimer;

export default handleActions(
    {
        [actions.contactreassigns.list.fetching]: (state, action) => {
            fetchingTimer = Date.now();

            return Object.assign({}, state, {
                list: Object.assign({}, state.list, {
                    fetching: true,
                    currentPage: action.payload.currentPage,
                }),
            });
        },

        [actions.contactreassigns.list.loaded]: {
            next: (state, action) => {
                fetchingTimer = Date.now() - fetchingTimer;

                return Object.assign({}, state, {
                    list: Object.assign(
                        {},
                        state.list,
                        getPaginationAndOrderData(action.payload.list.meta),
                        {
                            contactReAssign: action.payload.list.results.reduce(
                                (result, contactReAssigns) => {
                                    result[
                                        contactReAssigns.contactReAssignId
                                    ] = {
                                        contactReAssignId:
                                            contactReAssigns.contactReAssignId,
                                        contactReAssignStartAt:
                                            contactReAssigns.contactReAssignStartAt,
                                        contactReAssignRollbackedAt:
                                            contactReAssigns.contactReAssignRollbackedAt,
                                        contactAssignFrom: {
                                            contactId:
                                                contactReAssigns
                                                    .contactAssignFrom
                                                    .contactId,
                                            contactForenames:
                                                contactReAssigns
                                                    .contactAssignFrom
                                                    .contactForenames,
                                            contactSurname:
                                                contactReAssigns
                                                    .contactAssignFrom
                                                    .contactSurname,
                                            contactEmail:
                                                contactReAssigns
                                                    .contactAssignFrom
                                                    .contactEmail,
                                            contactTelephone:
                                                contactReAssigns
                                                    .contactAssignFrom
                                                    .contactTelephone,
                                        },
                                        contactAssignTo: {
                                            contactId:
                                                contactReAssigns.contactAssignTo
                                                    .contactId,
                                            contactForenames:
                                                contactReAssigns.contactAssignTo
                                                    .contactForenames,
                                            contactSurname:
                                                contactReAssigns.contactAssignTo
                                                    .contactSurname,
                                            contactEmail:
                                                contactReAssigns.contactAssignTo
                                                    .contactEmail,
                                            contactTelephone:
                                                contactReAssigns.contactAssignTo
                                                    .contactTelephone,
                                        },
                                    };
                                    return result;
                                },
                                {}
                            ),
                            fetching: false,
                            fetchingTime: fetchingTimer,
                        }
                    ),
                });
            },
            throw: (state, action) => {
                return Object.assign({}, state, {
                    list: Object.assign({}, initialState.list, {
                        error: true,
                    }),
                });
            },
        },

        [actions.contactreassigns.add.adding]: (state, action) => {
            return Object.assign({}, state, {
                update: Object.assign({}, initialState.add, {
                    updating: true,
                }),
            });
        },

        [actions.contactreassigns.add.added]: {
            next: (state, action) => {
                return Object.assign({}, state, {
                    add: Object.assign({}, initialState.add, {
                        contactReassign: action.payload.contactReassign,
                    }),
                    update: Object.assign({}, initialState.add),
                });
            },
            throw: (state, action) => {
                return Object.assign({}, state, {
                    update: Object.assign({}, initialState.add, {
                        error: true,
                    }),
                });
            },
        },

        [actions.contactreassigns.remove.prompt]: (state, action) => {
            const { contactReAssignId, contactReAssignName } = action.payload;

            return Object.assign({}, state, {
                remove: Object.assign({}, initialState.remove, {
                    contactReAssignId,
                    contactReAssignName,
                }),
            });
        },

        [actions.contactreassigns.remove.removing]: (state, action) => {
            return Object.assign({}, state, {
                remove: Object.assign({}, state.remove, {
                    removing: true,
                }),
            });
        },

        [actions.contactreassigns.remove.removed]: (state, action) => {
            return Object.assign({}, state, {
                remove: Object.assign({}, initialState.remove),
            });
        },

        [actions.contactreassigns.remove.reset]: (state, action) => {
            return Object.assign({}, state, {
                remove: Object.assign({}, initialState.remove),
            });
        },
    },
    initialState
);

export const loadContactReassigns = (currentPage, limit = 20) => {
    return (dispatch: Function, getState: Function, api: Function) => {
        dispatch(actions.contactreassigns.list.fetching({ currentPage }));

        return api
            .get(`/contactreassigns?limit=${limit}&page=${currentPage}`)
            .then(
                response =>
                    dispatch(
                        actions.contactreassigns.list.loaded(response.data)
                    ),
                err => dispatch(actions.contactreassigns.list.loaded(err))
            );
    };
};

export const loadContactReassignsDetails = contactId => {
    return (dispatch: Function, getState: Function, api: Function) => {
        dispatch(actions.contactreassigns.edit.fetching());

        return api
            .get(`/contactreassigns/${contactId}`)
            .then(
                response =>
                    dispatch(
                        actions.contactreassigns.edit.loaded(response.data)
                    ),
                err => dispatch(actions.contactreassigns.edit.loaded(err))
            );
    };
};

export const addContactReassignsDetails = contactReassignsData => {
    return (dispatch: Function, getState: Function, api: Function) => {
        dispatch(actions.contactreassigns.add.adding());

        return api.post(`/contactreassigns`, contactReassignsData).then(
            response => {
                dispatch(actions.contactreassigns.add.added(response.data));

                // this is needed to clear the 'dirty' flag and prevent warning that data may be lost
                dispatch(destroyForm('contactReassignsAddForm'));

                dispatch(
                    Notifications.success({
                        title: 'Contact reassign created',
                        message: 'The provided details have been saved.',
                        position: 'tc',
                        autoDismiss: 3,
                    })
                );
            },
            err => {
                dispatch(actions.contactreassigns.add.added(err));
                dispatch(
                    Notifications.error({
                        title: 'Creation failed',
                        message:
                            'An error occurred whilst creating this contact reassign. Please try again.',
                        position: 'tc',
                        autoDismiss: 5,
                    })
                );
                throw err;
            }
        );
    };
};

export const showDeleteContactReassignsPrompt = (
    contactReAssignId: string,
    contactReAssignName: string
) => {
    return actions.contactreassigns.remove.prompt({
        contactReAssignId,
        contactReAssignName,
    });
};

export const deletePromptReset = () => {
    return actions.contactreassigns.remove.reset();
};

export const removeContactReassigns = (
    contactReAssignId: string,
    contactReAssignName: string
) => {
    return (dispatch: Function, getState: Function, api: Function) => {
        dispatch(actions.contactreassigns.remove.removing());

        return api.delete(`/contactreassigns/${contactReAssignId}`).then(
            response => {
                dispatch(actions.contactreassigns.remove.removed());

                dispatch(
                    Notifications.success({
                        title: 'Contact Reassign deleted',
                        message: `The contact reassign for ${contactReAssignName} has been deleted.`,
                        position: 'tc',
                        autoDismiss: 3,
                    })
                );
            },
            err => {
                dispatch(actions.contactreassigns.remove.removed(err));
                dispatch(
                    Notifications.error({
                        title: 'Delete failed',
                        message:
                            'An error occurred whilst deleting this contact reassign. Please try again.',
                        position: 'tc',
                        autoDismiss: 5,
                    })
                );
                throw err;
            }
        );
    };
};



// WEBPACK FOOTER //
// ./src/redux/reducers/contactreassigns.js